<template>
    <course-list v-if="oneCategory" :categoryId="oneCategory.id" :globalSiteSetting="globalSiteSetting" />
    <course-category-list v-else :categories="categories" :link="coursesPage" :globalSiteSetting="globalSiteSetting" />
</template>

<script>
import CourseList from './CourseList.vue'
import CourseCategoryList from './CourseCategoryList.vue'
export default {
    name: 'zoezi-course-start-page',

    zoezi: {
        title: 'Courses start page',
        icon: 'mdi-format-list-text',
        addon: 'Courses'
    },

    components: {
        CourseList,
        CourseCategoryList
    },

    props: {
        coursesPage: {
            title: 'Page with course list',
            type: String,
            fulltype: 'page'
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        }
    },

    data: () => ({
    }),

    computed: {
        categories() {
            if (!this.$store.state.settings?.coursecategories) {
                return [];
            }

            return this.$store.state.settings?.coursecategories;
        },
        oneCategory() {
            return this.categories.length == 1 ? this.categories[0] : null;
        }
    }
}
</script>
